import { Check } from "lucide-react";

const DEFAULT_POINTS = [
  "Nie musisz szukać i porównywać firm",
  "Jasny proces od rozmowy do montażu",
  "Decyzję podejmujesz spokojnie, bez nacisku",
];

export default function BenefitsListSection({ points = DEFAULT_POINTS, eyebrow = "Twój spokojny proces" }) {
  return (
    <section
      id="dlaczego"
      className="py-16 lg:py-24 bg-white"
      data-testid="benefits-list-section"
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto">
          {eyebrow && (
            <p className="text-xs font-bold uppercase tracking-[0.18em] text-brand-blue">
              {eyebrow}
            </p>
          )}
          <h2 className={`${eyebrow ? "mt-3" : ""} font-heading font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-brand-ink`}>
            Dlaczego warto
          </h2>
        </div>

        <div className="mt-10 max-w-3xl mx-auto">
          <ul className="bg-brand-surface border border-brand-blue/10 rounded-3xl p-5 sm:p-8 space-y-3">
            {points.map((point, idx) => (
              <li
                key={idx}
                className="flex items-start gap-4 bg-white rounded-2xl p-4 sm:p-5 border border-brand-border shadow-sm"
                data-testid={`benefit-point-${idx}`}
              >
                <span className="grid place-items-center h-9 w-9 rounded-full bg-emerald-100 text-emerald-700 flex-shrink-0">
                  <Check className="h-5 w-5" strokeWidth={2.4} />
                </span>
                <p className="text-base sm:text-lg font-medium text-brand-ink leading-snug pt-1">
                  {point}
                </p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
